import {app} from "@/modules/app";
import {useStackRouteComponent} from "@/packages/stack-router/hooks/useStackRoute";

app.addRoutes([
    {
        name: 'app:order-feedback',
        parent: 'canvas',
        path: '/order-feedback',
        component: () => import('@/pages/shop/order-feedback.vue'),
        meta: {

        }
    },
    {
        parent: "public",
        path: "/call-tracking/phone",
        component: useStackRouteComponent(
            () => import("@/pages/site/contacts.dialog.vue")
        ),
        meta: {
            title: "Позвонить",
        },
    },
    {
        parent: "page",
        path: "/:pageUrl(pay|requisites)",
        component: () => import("@/pages/page/page.vue"),
        meta: {

        },
        props: true,
    },
    {
        parent: "page",
        path: "/bonus/",
        component: () => import("@/pages/page/page.vue"),
        meta: {
            layoutContentWide: true,
        },
        props: {
            pageUrl: "/bonus",
        },
    },
    {
        parent: "page",
        path: "/delivery/",
        component: useStackRouteComponent(
            () => import("@/pages/delivery/delivery.dialog.vue"),
            {
                routeComponent: () => import("@/pages/delivery/delivery.vue"),
                stackScreen: "md",
            }
        ),
        meta: {
            title: "Доставка и самовывоз",
        },
        props: true,
    },
    {
        parent: "public",
        path: "/office/:id",
        component: useStackRouteComponent(
            () => import("@/pages/company/office.dialog.vue")
        ),
    },

    {
        parent: "page",
        path: "/camera/",
        component: () => import("@/pages/camera/camera.vue"),
        meta: {
            title: "Камеры",
        },
        props: true,
    },

    {
        parent: "page",
        path: "/vacancies/",
        component: () => import("@/pages/vacancy/list.vue"),
        meta: {
            title: "Вакансии",
        },
        props: true,
    },
    {
        parent: "public",
        path: "/vacancy/:id",
        component: useStackRouteComponent(() => import("@/pages/vacancy/vacancy.dialog.vue")),
    },
    {
        parent: "page",
        path: "/faq/",
        component: () => import("@/pages/faq/faq.vue"),
        meta: {
            title: "Вопросы и ответы",
        },
        props: true,
    },
    {
        parent: "page",
        path: "/sitemap/",
        component: () => import("@/pages/site/sitemap.vue"),
        meta: {
            title: "Карта сайта",
        },
    },
    {
        parent: "page",
        path: "/contacts/",
        component: useStackRouteComponent(
            () => import("@/pages/site/contacts.dialog.vue"), {
                routeComponent: () => import("@/pages/site/contacts.vue"),
                stackScreen: 'md'
            }),
        meta: {
            title: "Контакты",
        },
    },
    {
        parent: "page",
        path: "/stories-demo/",
        component: () => import("@/pages/StoriesExample.vue"),
        meta: {
            title: "Stories Demo",
        },
    },
]);
